import React, { Component } from "react";
import { Link } from "react-router-dom";
import { resetPassword } from "../../../data-service";
import { emptyCheck, validatePassword } from "../../../utilities";
import Spinner from "../../User/Common/Spinner/Spinner";

class ResetPassword extends Component {
  state = {
    error: false,
    errorMessage: "",
    success: false,
    successMessage: "",
    showSpinner: false
  };

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }

  validate(password, confirmPassword) {
    if (emptyCheck(password)) {
      this.setState({ error: true, errorMessage: "Please enter password" });
      this.refs["inputSignupPassword"].focus();
      return false;
    } else if (emptyCheck(confirmPassword)) {
      this.setState({
        error: true,
        errorMessage: "Please confirm your password"
      });
      this.refs["inputConPassword"].focus();
      return false;
    } else if (!validatePassword(password)) {
      this.setState({
        error: true,
        errorMessage:
          "Please must contain at least one number, one lowercase and one uppercase letter. Atleast 6 characters required"
      });
      this.refs["inputSignupPassword"].focus();
      return false;
    } else if (password !== confirmPassword) {
      this.setState({
        error: true,
        errorMessage: "Password and confirm password should be same"
      });
      this.refs["inputSignupPassword"].focus();
      this.refs["inputConPassword"].focus();
      return false;
    } else {
      this.setState({ error: false, errorMessage: "" });
      return true;
    }
  }

  resetPasswordClicked() {
    const password = this.refs["inputSignupPassword"].value;
    const confirmPassword = this.refs["inputConPassword"].value;
    if (this.validate(password, confirmPassword)) {
      this.showSpinner(true);
      let data = {
        id: this.props.match.params.id,
        userId: "",
        email: "",
        NewPassword: password,
        ConfirmPassword: confirmPassword
      };
      // console.log(data);
      resetPassword(data)
        .then(response => {
          this.showSpinner(false);
          this.setState({
            success: true,
            successMessage: `Password has been successfully reset. Login with new password.`
          });
        })
        .catch(error => {
          this.showSpinner(false);
          // console.log(error);
          if (error.response.data.ModelState) {
            this.setState({
              error: true,
              errorMessage: error.response.data.ModelState[""].join(",")
            });
          }
        });
    }
  }

  render() {
    let errorPlaceholder = null;
    if (this.state.error) {
      errorPlaceholder = (
        <p className="alert alert-danger text-center">
          {this.state.errorMessage}
        </p>
      );
    }
    if (this.state.success) {
      errorPlaceholder = (
        <p className="alert alert-success text-center">
          {this.state.successMessage}
        </p>
      );
    }
    return (
      <div className="card card-container" id="signupbox">
        <Spinner showSpinner={this.state.showSpinner} />
        {errorPlaceholder}
        <form className="form-signin">
          <input
            type="password"
            ref="inputSignupPassword"
            className="form-control"
            placeholder="Password"
          />
          <input
            type="password"
            ref="inputConPassword"
            className="form-control"
            placeholder="Confirm Password"
          />
          <button
            className="btn btn-lg btn-primary btn-block btn-signin"
            type="button"
            onClick={() => this.resetPasswordClicked()}
          >
            Reset Password
          </button>
          <Link to="/login">Sign In</Link>
        </form>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/containers/Login/ResetPassword/ResetPassword.js